
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class LocaleListItem extends Vue {
  @Prop() code!: string
  @Prop() name!: string
}
